import React from "react";
import PropTypes from "prop-types";
import { Header } from "../header";
import { Sticky } from "../../basic/sticky";
import { HeaderSearch } from "../header-search";
import { CtaWrapper, LogoWrapper, DefaultMenu, Sidebar, Login } from "../header-helper-components";
import { SINGLE_LAYER_ROOT_MARGIN } from "../../../constants";
import { accessCheck } from "../../../../isomorphic/utils";

import "./single-layer-header-one.m.css";

const singleLayerHeaderOne = props => {
  return (
    <Sticky rootMargin={SINGLE_LAYER_ROOT_MARGIN}>
      <article styleName="sticky">
        <div styleName="sidebar">
          <Sidebar {...props} {...props.isSidebarVisible} dataTestId="hamburger-icon" headerClass="single-layer" />
        </div>
        <div styleName="logo">
          <LogoWrapper {...props} />
        </div>
        <div styleName="default-menu">
          <DefaultMenu {...props} isSingleLayer />
        </div>
        <div styleName="cta-search-wrapper">
          <div styleName="cta">
            <CtaWrapper {...props} isSingleLayer />
          </div>
          {accessCheck(props.enableSSO) && (
            <div styleName="login">
              <Login {...props} headerType="single-layer" />
            </div>
          )}
          <div styleName="search">
            <HeaderSearch {...props} dataTestId="search-icon" headerType="single-layer" />
          </div>
        </div>
      </article>
    </Sticky>
  );
};

singleLayerHeaderOne.propTypes = {
  isSidebarVisible: PropTypes.bool,
  toggleSearchForm: PropTypes.bool,
  hideSearchForm: PropTypes.bool,
  enableSSO: PropTypes.bool
};

const HeaderTemplate = ({ showHeaderRowOnly = false }) => (
  <Header renderTemplate={singleLayerHeaderOne} showHeaderRowOnly={showHeaderRowOnly} />
);

HeaderTemplate.propTypes = {
  showHeaderRowOnly: PropTypes.bool
};

export default HeaderTemplate;
